<template>
    <dropdown
        :key="isMobile"
        v-c-tooltip="{
            content: trans('navigation.notifications'),
            placement: 'bottom',
            trigger: isMobile ? ['none'] : ['hover'],
        }"
        :auto-close="'outside'"
        :caret="false"
        class="notification-center"
        variant="nav-item"
    >
        <template #toggler>
            <icon icon="cil-bell" style="width: 22px; height: 20px" />
            <span v-if="store.notifications?.data?.length" class="notification-count translate-middle start-100 top-0" v-text="store.counter" />
        </template>
        <dropdown-header class="flex! flex-wrap items-center justify-between gap-4">
            <strong>{{
                trans('notification_center.summary', {
                    count: store.unreadCount,
                })
            }}</strong>
            <a
                v-if="store.notifications?.data?.length && !store.isLoading"
                :href="$route('notifications.mark_as_read')"
                @click.stop.prevent="store.markAllAsRead"
                >{{ trans('notification_center.action.mark_all_as_read') }}</a
            >
            <spinner v-if="store.isLoading" />
        </dropdown-header>
        <div v-if="store.notifications?.data?.length" class="notification-item-container">
            <notification
                v-for="notification in store.notifications.data"
                :key="notification.id"
                :notification="notification"
                class="notification-item"
                @read="store.removeReadNotification"
            />
            <div ref="intersectionObserver" style="min-height: 1px" />
        </div>
    </dropdown>
</template>
<script setup>
import Notification from '@/Components/NotificationCenter/Notification.vue';
import Dropdown from '@/Components/Dropdown.vue';
import DropdownHeader from '@/Components/DropdownHeader.vue';
import { isMobile } from '@/Utils/UseMedia';
import { onMounted, onUnmounted, ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { trans } from '@/mixins/i18n.js';
import { useNotificationsStore } from '@/stores/notifications';

const store = useNotificationsStore();
const intersectionObserver = ref(null);

onMounted(() => {
    store.start();
    store.loadUnreadNotifications();
});

const { stop } = useIntersectionObserver(intersectionObserver, ([entry], observerElement) => {
    if (entry.isIntersecting) {
        store.loadUnreadNotifications();
    }
});

onUnmounted(() => {
    store.stop();
    stop();
});
</script>
<style scoped>
@media (max-width: 576px) {
    :deep(.dropdown-menu) {
        position: fixed !important;
        left: 50% !important;
        top: 45px !important;
        transform: translate(-50%) !important;
    }
}
</style>
